import { render, staticRenderFns } from "./SubmitQues.vue?vue&type=template&id=5570aa40&scoped=true&"
import script from "./SubmitQues.vue?vue&type=script&lang=js&"
export * from "./SubmitQues.vue?vue&type=script&lang=js&"
import style0 from "./SubmitQues.vue?vue&type=style&index=0&id=5570aa40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5570aa40",
  null
  
)

export default component.exports